import { render } from "./LocaleSwitcher.vue?vue&type=template&id=766b6a88&scoped=true"
const script = {}

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=766b6a88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766b6a88"]])

export default __exports__